import { Star } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { cn } from '~/lib/utils'
import { AppsFooter } from './apps-footer'

interface RatingProps {
	defaultValue: number
	className?: string
}

export const Rating = ({ defaultValue, className }: RatingProps) => {
	const valueRoundedToLowerHalf = Math.floor(defaultValue * 2) / 2

	return (
		<div className={cn('flex gap-x-0.5', className)}>
			{Array.from({ length: 5 }, (_, i) => {
				const diff = Math.min(Math.abs(i - valueRoundedToLowerHalf), 1)

				return (
					<div
						key={i}
						className='relative'
					>
						<div
							style={{
								width: i < defaultValue ? `${100 * diff}%` : 0,
							}}
							className='absolute overflow-hidden'
						>
							<Star
								className='size-4 fill-primary stroke-primary'
								strokeWidth={0}
							/>
						</div>

						<Star
							className='size-4 fill-slate-200'
							strokeWidth={0}
						/>
					</div>
				)
			})}
		</div>
	)
}

export const BaselineAndRating = () => {
	const { t } = useTranslation()

	return (
		<div className='flex flex-col gap-6'>
			<div className='flex flex-col gap-2 leading-none'>
				<p className='font-bold text-[30px] text-primary'>cocoon space</p>

				<p>{t('cwFooter:baseline')}</p>

				<div className='flex items-center text-sm'>
					4,8
					<Rating
						className='mx-2'
						defaultValue={4.8}
					/>
					<a
						href='https://www.google.com/maps/search/cocoon+space/@48.8665006,2.306261,13z?entry=ttu'
						target='_blank'
						className='text-slate-500'
					>
						449 avis
					</a>
				</div>
			</div>

			<AppsFooter />
		</div>
	)
}
